import request from '@/api/request';

// 获取验证码
export function sendCode(params) {
	return request.get('/api/account/sendCode', params)
}

// 注册
export function register(data) {
	return request.post('/api/account/register', data)
}

// 账号密码登录
// export function login(data) {
// 	return request.post('/api/account/login', data)
// }

// 验证码登录
export function smsLogin(params) {
	return request.get('/api/account/phoneLogin', params)
}

// 忘记密码
export function forget(data) {
	return request.post('/api/login_password/forget', data)
}

// 退出登录
export function logout(data) {
	return request.post('/api/account/logout', data)
}
//设置
export function setContent(params) {
	return request.get('/public/getSetting', params)
}
//分类
export function listClassify(params) {
	return request.get('/public/listClassify', params)
}
//获取用户信息
export function userInformation(params) {
	return request.get('/api/account/info', params)
}
//获取知识库
export function knowledgeBase(params) {
	return request.get('/public/listRepository', params)
}
//知识库详情
export function knowledgeBaseDetails(params) {
	return request.get('/public/repositoryDetails', params)
}
//新增病例
export function newlyAddedCases(data) {
	return request.post('/api/caseReport/save', data)
}
//病例列表
export function caseList(params) {
	return request.get('/api/caseReport/page', params)
}
//删除病例
export function deleteCase(params) {
	return request.get('/api/caseReport/del', params)
}
//病例详情
export function caseDetails(params) {
	return request.get('/api/caseReport/info', params)
}
//修改用户信息
export function modifyUser(data) {
	return request.post('/api/account/update', data)
}
//实名
export function realNameRegistration(data) {
	return request.post('/api/account/real', data)
}

//意见反馈
export function opinionInterface(data) {
	return request.post('/api/opinion/save', data)
}
//开始答题
export function answer(params) {
	return request.get('/api/result/init', params)
}
// 获取问题
export function getTheProblem(params) {
	return request.get('/public/listQuestion', params)
}
//提交答案
export function submitResults(data) {
	return request.post('/api/result/history', data)
}
//结束答题
export function endTheQuiz(params) {
	return request.get('/api/result/overNew', params)
}
//诊断结果列表
export function resultList(params) {
	return request.get('/api/result/page', params)
}
//诊断结果详情
export function diagnosticResultDetails(params) {
	return request.get('/api/result/info', params)
}
//获取问题信息
export function problemInformation(params) {
	return request.get('/public/getQuestionInfo', params)
}
//天气
export function weather(params) {
	return request.get('/public/getWeather', params)
}
//计量诊断
export function quantitativeDiagnosis(params) {
	return request.get('/public/getDisease', params)
}
//获取新问题
export function overallNumber(params) {
	return request.get('/public/getQuestionInfoNow', params)
}
//新的问题
export function newProblem(params) {
	return request.get('/public/getQuestionNew', params)
}
//结束答题
export function newlyCompletedQuiz(params) {
	return request.get('/api/result/overNew', params)
}